/* unplugin-vue-components disabled */import script from "./EmployeesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeesTable.vue?vue&type=script&setup=true&lang=js"

import "./EmployeesTable.vue?vue&type=style&index=0&id=242c1624&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242c1624"]])

export default __exports__